import React, { Component } from 'react'
import styled from 'styled-components'
import gql from 'graphql-tag'
import { Container, Row, Col, media } from 'styled-bootstrap-grid'
import { compose } from 'react-apollo'
import { Link } from 'react-router-dom'
import scrollTo from 'animated-scroll-to'

import getRelativeUrl from 'utils/getRelativeUrl'
import { Text } from 'ui/styles/utils'
import withQuery from 'containers/withQuery'
import withNav from 'containers/withNav'
import Logo from 'ui/components/generic/LogoLight'
import ArrowLink from 'ui/components/generic/ArrowLink'
import CircleArrow from 'ui/components/generic/CircleArrow'

class Footer extends Component {
  render() {
    const {
      optionsFooter: {
        phoneNumber,
        email,
        address,
      },
      optionsFooterLoading,
      menuItems,
      menuItemsSecondary
    } = this.props

    if (optionsFooterLoading) return null

    return (
      <Wrapper>
        <PrimaryContent>
          <Container fluid>
            <Row>
              <Col
                sm={4}
                md={4}
                lg={4}
                lgOffset={1}
                xsOrder={2}
                smOrder={1}
              >
                <Row>
                  <Col
                    lg={6}
                  >
                    <Text
                      size="xs"
                      as="h4"
                    >
                      Kontakt
                    </Text>
                    <Text
                      size="xs"
                    >
                      <a href={`tel:${phoneNumber}`}>{phoneNumber}</a>
                    </Text>
                    <Text
                      size="xs"
                    >
                      <a href={`mailto:${email}`}>{email}</a>
                    </Text>
                  </Col>
                  <SpacedCol
                    lg={6}
                  >
                    <Text
                      size="xs"
                      as="h4"
                    >
                      Adresse
                    </Text>
                    <Text
                      size="xs"
                      dangerouslySetInnerHTML={{ __html: address }}
                      mb={30}
                    />
                  </SpacedCol>
                </Row>
              </Col>
              
              <Col
                sm={4}
                md={4}
                lg={2}
                xsOrder={1}
                smOrder={2}
              >
                <LogoWrapper>
                  <Link to="/">
                    <Logo />
                  </Link>
                  <CircleArrow onClick={() => scrollTo(0)} />
                </LogoWrapper>
              </Col>
              <Col
                sm={4}
                md={4}
                lg={4}
                lgOffset={1}
                xsOrder={3}
                smOrder={3}
              >
                <LinkRow>
                  {menuItems && menuItems.map((item, index) => (
                    <Col
                      lg={6}
                      key={`primaryMenuItem-${index}`}
                    >
                      <Text size="xs">
                        <ArrowLink to={getRelativeUrl(item.url)}>{item.label}</ArrowLink>
                      </Text>
                    </Col>
                  ))}
                </LinkRow>
              </Col>
            </Row>
          </Container>
        </PrimaryContent>
        <SecondaryContent>
          <Container fluid>
            <Row>
              <Col
                sm={6}
                lg={5}
                lgOffset={1}
                xsOrder={1}
              >
                <Text size="xxs">Copyright {new Date().getFullYear()} EdTalk - All rights reserved</Text>
              </Col>
              <Col
                sm={6}
                lg={5}
              >
                {menuItemsSecondary && menuItemsSecondary.map((item, index) => (
                  <Text
                    size="xxs"
                    as="span"
                    key={`secondaryMenuItem-${index}`}
                  >
                    <Link to={getRelativeUrl(item.url)}>{item.label}</Link>
                  </Text>
                ))}
              </Col>
            </Row>
          </Container>
        </SecondaryContent>
      </Wrapper>
    )
  }
}

export default compose(
  withQuery(() => gql`
    {
      optionsFooter {
        phoneNumber
        email
        address
      }
    }
  `, 'optionsFooter'),
  withNav('FOOTER_NAV'),
  withNav('FOOTER_NAV_SECONDARY', 'secondaryMenuItems')
)(Footer)

// Styles
const Wrapper = styled.div`
  position: relative;
  z-index: 11; /* place above decoration line */
  color: #fff;
`

const PrimaryContent = styled.div`
  padding: 40px 0;
  background-color: ${props => props.theme.colors.primary};

  a {
    color: #fff;
    font-weight: 600;
    margin-bottom: 5px;
  }
`

const SecondaryContent = styled.div`
  background-color: ${props => props.theme.colors.primaryDarker};
  padding: 10px 0;

  span {
    display: inline-block;
    margin-right: 20px;

    a {
      color: #fff;
    }

    &:last-child {
      margin-right: 0;
    }
  }

  ${Col} {
    display: flex;
    height: 26px;
    align-items: center;
    justify-content: center;

    ${media.sm`
      justify-content: flex-start;
    `}

    &:last-child {
      ${media.sm`
        justify-content: flex-end;
      `}
    }

    ${media.xs`
      justify-content: flex-start;
    `}
  }
`

const LogoWrapper = styled.div`
  display: flex;
  height: 185px;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;

  svg {
    display: inline-block;
    max-width: 240px;
    height: auto;
    cursor: pointer;
  }

  a {
    width: 50%;
    
    svg {
      width: 100%;
    }

    ${media.xs`
      width: 25%;
    `}
  }

  ${media.xs`
    height: auto;
    margin-bottom: 25px;
  `}

  ${media.sm`
    flex-direction: column;
  `}
`

const LinkRow = styled(Row)`
  text-align: right;

  ${media.xs`
    text-align: left;
  `}

  ${media.lg`
    text-align: left;
  `}
`

const SpacedCol = styled(Col)`
  margin-top: 35px;

  ${media.lg`
    margin-top: 0;
  `}
`



// WEBPACK FOOTER //
// ./src/ui/components/Footer.js